import src from "IMAGE";
export default { src, width: 1920, height: 368, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPUlEQVR42hWJyQ0AIAgEFUwkhEMexhL8239xwnx2stMQcbj7MbOb+yLilYvIAQBsPSGiycwrz62qu3wm1T5zuAMQgUaDMgAAAABJRU5ErkJggg=="};
